import { enums } from '@adc/sdk';
import * as graph from '@adc/sdk';
export const findSellerRepresentative = (listingParties, viewingFrom) => {
    const listingAgent = listingParties?.find(party => party?.party_role === enums.ListingPartyRole.ListingAgent);
    if (viewingFrom === graph.enums.CurrentTargetAudience.Staff &&
        !listingAgent) {
        return listingParties?.find(party => party?.party_role === enums.ListingPartyRole.PrivateSeller);
    }
    else {
        return listingAgent;
    }
};
//# sourceMappingURL=utils.js.map